module.exports = __webpack_public_path__ + "img/poster1.261ece5e.png";